import React, { useMemo } from 'react'
import classNames from 'classnames'

export interface AvatarProps {
  src?: string
  name: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  subtle?: boolean
}

export function Avatar({ src, name, size = 'md', subtle }: AvatarProps) {
  const initials = useMemo(() => name?.split(' ').map((n) => n[0]), [name])
  return (
    <span
      className={classNames('inline-flex items-center justify-center rounded-full bg-foreground shrink-0', {
        'h-6 w-6': size === 'xs',
        'h-8 w-8': size === 'sm',
        'h-10 w-10': size === 'md',
        'h-12 w-12': size === 'lg',
        'h-14 w-14': size === 'xl',
        'bg-muted border border-border': subtle
      })}
    >
      {src ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img className='inline-block object-contain rounded-full w-full h-full' src={src} alt={name} />
      ) : (
        <span
          className={classNames('font-medium leading-none text-background uppercase', {
            'text-xs !text-[10px]': size === 'xs',
            'text-sm': size === 'sm',
            'text-md': size === 'md',
            'text-lg': size === 'lg',
            'text-xl': size === 'xl',
            'text-foreground': subtle
          })}
        >
          {initials}
        </span>
      )}
    </span>
  )
}
